import { render, staticRenderFns } from "./ShippingRateGrid.vue?vue&type=template&id=25fc25bc&scoped=true&"
import script from "./ShippingRateGrid.vue?vue&type=script&lang=js&"
export * from "./ShippingRateGrid.vue?vue&type=script&lang=js&"
import style0 from "./ShippingRateGrid.vue?vue&type=style&index=0&id=25fc25bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fc25bc",
  null
  
)

export default component.exports